var _circle, _circle2, _circle3, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSliderClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    stroke: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    stroke: "#808080",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9997 10.9992C10.9997 10.8285 11.065 10.6578 11.195 10.5278L14.5277 7.19383C14.7883 6.93317 15.2103 6.93317 15.471 7.19383C15.731 7.4545 15.731 7.87583 15.471 8.1365L12.609 10.9992L15.471 13.8618C15.731 14.1225 15.731 14.5438 15.471 14.8045C15.2103 15.0652 14.7883 15.0652 14.5277 14.8045L11.195 11.4705C11.065 11.3405 10.9997 11.1698 10.9997 10.9992Z",
    fill: "#484848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33367 10.9992C6.33367 10.8285 6.399 10.6578 6.529 10.5278L9.86167 7.19383C10.1223 6.93317 10.5443 6.93317 10.805 7.19383C11.065 7.4545 11.065 7.87583 10.805 8.1365L7.943 10.9992L10.805 13.8618C11.065 14.1225 11.065 14.5438 10.805 14.8045C10.5443 15.0652 10.1223 15.0652 9.86167 14.8045L6.529 11.4705C6.399 11.3405 6.33367 11.1698 6.33367 10.9992Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderClose);
export default __webpack_public_path__ + "static/media/sliderClose.16dc8849c5556de465fa3f91f69572a0.svg";
export { ForwardRef as ReactComponent };